import React, { useEffect, useRef, useState } from "react";
import styles from './index.module.scss'
import { useExchangeRecord } from "./hooks/useAwardRecord";
import DateFilter from "../betOrderRecords/compoments/dateFilter";
import AwardList from "./compoments/awardList";
import LoadingUI from "@/compoments/loadingUI";
import PaginationTo from "../betOrderRecords/compoments/paginationTo";
import FadeIn from "@/compoments/fadeIn";
import { useTranslation } from "react-i18next";

const AwardRecord = () => {
  const { t } = useTranslation('record')
  // 初始筛选条件
  const getFilters = () => ({
    startTime: ut.getDateString(0), // 开始日期 今天
    endTime: ut.getDateString(0), // 结束日期
    pageNum: 1,  // 当前页码
    pageSize: 10, // 每页记录数
  })
  // 状态管理更新筛选条件
  const [filters, setFilters] = useState(getFilters)
  // 获取兑奖记录
  const { list, totalPage, totalRecord, isLoading } = useExchangeRecord(filters)

  // 加入真实高度缓存逻辑
  const contentRef = useRef<HTMLDivElement>(null)
  const [contentHeight, setContentHeight] = useState<number | undefined>()
  useEffect(() => {
    if (!isLoading  && contentRef.current) {
      const height = contentRef.current.getBoundingClientRect().height
      setContentHeight(height)
    }
  }, [isLoading, list])
  

  return (
    <FadeIn>
    <div className={styles.awardRecord}>
      <div className={styles.title}>{t('rewardRecord')}</div>

      {/* 日期筛选 */}
      <DateFilter
        value={{startAt: filters.startTime, endAt: filters.endTime}}
        onChange={(start, end) =>
          setFilters(prev => ({
            ...prev,
            startTime: start,
            endTime: end,
            _refresh: Date.now(), // 总是刷新，即使时间一样
          }))
        }
      />

      <LoadingUI data={ list } loading={isLoading} height={contentHeight}>
        <div ref={contentRef}>
          {/* 领奖记录列表 */}
          <AwardList lists={list} />
        </div>
      </LoadingUI>

      {/* 分页器 */}
      {totalRecord >0 && <PaginationTo 
        current={filters.pageNum}
        total={totalRecord}
        pageSize={filters.pageSize}
        onChange={(page) => {
          setFilters(prev => ({ 
            ...prev, 
            pageNum: page,
          }));
        }}
      />}
    </div>
    </FadeIn>
  )
}

export default AwardRecord